const COMMISSION_SUMMARY = {
  totalSalesPrice: {
    label: 'Comissão de Marketplace (Produtos não Ambev)',
    tooltipText: 'Comissão aplicada nas vendas de produtos marketplace.',
  },
  totalPlatformFee: {
    label: 'Taxa de plataforma',
    tooltipText:
      'Percentual cobrado sobre o valor do pedido, conforme contrato com a loja.',
  },
  downloadButtonTextSuffix: 'comissões por pedido',
  errorMessage:
    'Houve um erro ao carregar o resumo de taxas e comissões. Tente novamente mais tarde.',
  errorMessageCommissionTotalMismatch:
    'Restitution details marketplace total mismatch',
}

export default COMMISSION_SUMMARY
